/**
 * Angular import.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Constant imports.
 */
import { TEMPLATE_TYPE } from '../../../constants/app.constants';

/**
 * import service
 */
import { UserStoryService } from 'src/app/dataservices/userStory/user-story.service';

/**
 * Used to show the selection of custom template which include background, template, mweb.
 */
@Component({
  selector: 'app-custom-template',
  templateUrl: './custom-template.component.html',
  styleUrls: ['./custom-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomTemplateComponent implements OnInit {


  constructor(public storyServ: UserStoryService) {

  }

  /**
   * Type of template
   * 0 for background color.
   * 1 for template images
   * 2 for the responsive templates contain both background and template.
   */
  @Input() customType: number;

  /**
   * Heading for the templates.
   */
  @Input() headingText: string;

  /**
   * Template src or gradient.
   */
  @Input() templates;

  /**
   * template list
   */
  @Input() templateList;

  @Input() customTemplateType;

  @Input() defaultTemplateCode;
  /**
   * Emit selected template.
   */
  @Output() emitSelectTemplate: EventEmitter<{ src: string; gradient: string }> = new EventEmitter();

  /**
   * emit selected template
   */
  @Output() emitBackGroundTemplate: EventEmitter<string> = new EventEmitter();

  /**
   * Pre Selected template.
   * Type of templates
   */
  public selectedTemplate = 0;
  public templateType = TEMPLATE_TYPE;

  /**
   * Pre selected template.
   */
  ngOnInit(): void {
    if (this.customType === TEMPLATE_TYPE.BACKGROUND) {
      this.selectTemplate(0);
    }
    else if (this.customType === TEMPLATE_TYPE.M_WEB || this.customType === TEMPLATE_TYPE.TEMPLATE) {
      let index = this.templates.findIndex(res => {
        return res?.value === this.defaultTemplateCode;
      });
      index = index === -1 ? 0 : index;
      this.selectTemplate(index);
    }
  }

  /**
   * Necessary instances.
   */
  trackByFn(index: any, item: any): any {
    return index;
  }

  /**
   * Select the particular template.
   */
  selectTemplate(index: number): void {
    this.selectedTemplate = index;
    if (this.customType ===  TEMPLATE_TYPE.BACKGROUND) {
       this.onEmitSelectTemplate(index);
    }
    else if (this.customType === TEMPLATE_TYPE.M_WEB || TEMPLATE_TYPE.TEMPLATE) {
      this.emitBackGroundTemplate.emit(this.templates[index]?.value);
    }
  }
  /**
   * emit back
   */

  /**
   * Emit selected template.
   */
  onEmitSelectTemplate(index: number): void {
    this.emitSelectTemplate.emit(this.templates[index]);
  }

  /**
   * get background image 
   */
  getBackGroundImage(backGroundStyle): any {
     if  (this.customType &&   backGroundStyle.code) {
      if (backGroundStyle.code.indexOf('http') !== -1 || backGroundStyle.code.indexOf('base64') !== -1) {
        return {
          'background-image': 'url(' + backGroundStyle.code + '), url(assets/images/grandround/image_placeholder.svg)'
        };
      }
      else {
       const backGroundUrl =this.storyServ.fileCodeUrlMap.get(backGroundStyle.code);
       return backGroundUrl;
      }
    }
  }
}
